import { currentPage } from '../common/layout';
import {commentsCountUpdate, loadCommentsNumber, disableAdsInEmbedVideo, initCoralComments, coralCommentsEdition, initCoralByCommentsBtnEditions, getCookie, checkAndFilterCoralCommentsAmountToShow, setupScrollOnClick, getAdfeed } from '../common/utils/fn';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
import { getFaqWidget } from '../common/widgets/widget-faq-loader';
import { getCompareImages } from '../common/widgets/widget-compare-images-loader';
import { getPointsOfInterest } from '../common/widgets/widget-points-of-interest-loader';
import 'jquery-mousewheel';
// import '../common/lightgallery/jquery-lightgallery';
// import '../common/lightgallery/jquery-lightgallery-aside';
// import '../common/lightgallery/jquery-lightgallery-additional';
// import '../common/lightgallery/jquery-lightgallery-topside';
// import '../common/lightgallery/jquery-lightgallery-custom-content';
// import '../common/msnt/msnt-lightslider.js';
// import '../common/lightzoom';
// import 'jquery-scrolltie';
// import { cmpBubbles } from '../common/cmp-bubbles';
// import { msntPhotoThumbGallery } from '../common/msnt/msnt-loader';
import { getNewsletterWidget } from '../common/widgets/widget-newsletter-loader';
import { loadDisqusComments } from '../common/jquery-lazy-load-3rd-party';
import { getStickyVideo } from '../common/utils/sticky-video-loader';
import { topComments } from '../common/top-comments';
// import '../common/jquery-lazy-load-3rd-party';
// import '../common/modernizr';
// import '../common/player';
// import '../common/lazyload.picture';
// import '../common/lot-linx-car';
// import { renderEbay } from '../common/widgets/widget-ebay';
// import { throttle, debounce } from 'throttle-debounce';
import device from 'current-device';

import { msntConsent } from '../common/msnt-consent';
// import '../common/scroll-depth';

currentPage.pageInit = ($page, pageData, pageId) => {
  var $window = $(window),
    $body = $(document.body),
    $page = $('#' + pageId),
    $recommendedBox = $page.find('.recommendedBox'),
    $dataEdtn = $('body').data('edtn'),
    $pageIsRtl = $('body').data('rtl');
    var isVideoArticle = document.querySelector('.videowrapper');
    let cpUserIsLogged = $body.hasClass('cpauthenticated');
    // cpass
    const $contentpassEditions = ['fr', 'ar', 'us', 'it', 'me', 'es', 'tr', 'id'];
    var cpAuthhint = document.cookie.includes('_cpauthhint=1');
    let isDevEnv = document.body.classList.contains('development');
    // const contentPassCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB', 'UA'];
    let abtestCookie = getCookie('abtest');

  if (!abtestCookie || abtestCookie == 'Auto-v1.4' ||  abtestCookie == 'Auto-v1.3') {
    import(/* webpackPrefetch: true */ '../common/scroll-depth')
    .then(module => {
      module.trackSectionScrollDepth($('article'));
    })
  }

  // cpass
  if (!cpAuthhint) {
    disableAdsInEmbedVideo();
  }

  checkAndFilterCoralCommentsAmountToShow();
  setupScrollOnClick('.m1-article-meta_comments', '#comments');
// cpass

if (!cpAuthhint) {
  topComments.init({
    config: { active: 1 },
  });
}

  msntConsent.initEmbeds($('.postBody'));
  // cpass
  if (cpAuthhint) {
    msntConsent.initEmbedVideo($('.root'));
  }

const shareData = {
  title: document.getElementsByClassName('main-article-heading')[0].textContent,
  text: document.getElementsByClassName('sub-article-heading')[0].textContent,
  url: document.location.href,
};

let shareButton = document.getElementsByClassName('m1-article-meta_share')[0];
// console.log(shareButton, window.device.type);
if (shareButton !== null) {
  shareButton.addEventListener("click", async () => {
    if (window.device.type !== 'desktop') {
      gtmDataLayer.push({
        event: 'socialButtonClicked',
      });
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log(err);
      }
    }
  });
}

  window.addEventListener('message', function(e){
    let data = e.data;
    if (data === 'newComment') {
      gtmDataLayer.push({
        event: data,
      });
    }
  })

  // scrollingToComments();
  let pointsOfInterestWidget = document.querySelector('[data-widget="points-of-interest"]');
  if (pointsOfInterestWidget) {
    getPointsOfInterest().then((api) => {
      api.pointsOfInterest();
    });
  }

  let compareImagesWrapper = document.querySelector('[data-widget="compare-images"]');
  if (compareImagesWrapper) {
    getCompareImages().then((api) => {
      api.compareImages();
    });
  }

  let faqWidget = document.querySelector('.widget_faq');
  if (faqWidget) {
    getFaqWidget().then((api) => {
      api.faqAccordeon();
    });
  }

  let newsLetterWidget = document.querySelector('.widget-newsletter');
  if (newsLetterWidget) {
    getNewsletterWidget().then((api) => {
      api.newsletter();
    });
  }

  let facebookWrapper = document.getElementsByClassName('facebook-video-wrapper')[0];

  if (facebookWrapper) {
    (
      () => {
        let fbSizer = facebookWrapper.querySelector('.sizer');
        let videoIframe = facebookWrapper.querySelector('iframe');

        let fbSizerHeight = fbSizer.offsetHeight;
        let videoIframeWidth = videoIframe.getAttribute('width');
        let videoIframeHeight = videoIframe.getAttribute('height');
        let iframeAspectRatio = videoIframeHeight / videoIframeWidth;
        
        if (iframeAspectRatio === 1) {
          videoIframe.height = fbSizerHeight;
          videoIframe.width = fbSizerHeight;
        } else if (iframeAspectRatio === 0.5625) {
          facebookWrapper.classList.add('facebook-iframe-sizer');
        } else if (iframeAspectRatio > 1) {
          videoIframe.height = fbSizerHeight;
          videoIframe.width = fbSizerHeight / iframeAspectRatio;
        } else {
          videoIframe.height = fbSizerHeight;
          facebookWrapper.classList.add('facebook-iframe-sizer');
        }
      }
    )(); 
  }

  if (isVideoArticle != null) {
    getStickyVideo().then((api) => {
      api.stickyVideo($dataEdtn, $window);
    });
  }

  if ($dataEdtn == 'de' || $dataEdtn == 'ev_de' && !cpAuthhint) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  let lightzoomWidget = document.querySelector('.lightzoom');
  if (lightzoomWidget && device.type !== 'mobile') {
    import(/* webpackPrefetch: true */ '../common/lightzoom-loader')
    .then(module => {
      module.initializeLightzoom();
    })
  } else if (lightzoomWidget && device.type == 'mobile') {
    let lightzoomWidgets = document.querySelectorAll('.lightzoom');
    for (let lightzoomWidgetItem of lightzoomWidgets) {
      lightzoomWidgetItem.addEventListener('click', (e) => {
        e.preventDefault();
        return;
      })
    }
  }

  import(/* webpackPrefetch: true */ '../common/msnt/msnt-photo-thumb-gallery')
    .then(module => {
      module.msntPhotoThumbGallery();
  })

  //cpass
  if (($dataEdtn == 'ev_ar'  && !cpAuthhint) || $dataEdtn == 'br' || ($dataEdtn == 'ar' && !cpAuthhint)) {
    commentsCountUpdate();
    loadDisqusComments();
  }

  //bannerLazyload();
  // if (!coralCommentsEdition.includes($dataEdtn)) loadCommentsNumber();
  if (!coralCommentsEdition.includes($dataEdtn) && !cpAuthhint) loadCommentsNumber();
  const coralContainer = $('#coral_thread');
  const showCoralCommentsBtn = document.querySelector('#show-disqus');
  // const showCoralCommentsBtnTopComments = document.querySelector('.m1-top-comments__empty > span');
  const topCommentsEmptyBlock = document.querySelector('.m1-top-comments');

  if (coralCommentsEdition.includes($dataEdtn) && initCoralByCommentsBtnEditions.includes($dataEdtn) && coralContainer.length) {
    showCoralCommentsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      initCoralComments();
      if (showCoralCommentsBtn && topCommentsEmptyBlock) {
        showCoralCommentsBtn.remove();
        topCommentsEmptyBlock.remove();
      }
    });
    // if (showCoralCommentsBtnTopComments) {
    //   showCoralCommentsBtnTopComments.addEventListener('click', () => {
    //     initCoralComments();
    //     showCoralCommentsBtn.remove();
    //     topCommentsEmptyBlock.remove();
    //   });
    // }
  } else if (coralCommentsEdition.includes($dataEdtn) && coralContainer.length) {
    initCoralComments();
  }
  $('.photo-title a').on('click', function(e) {
    e.stopPropagation();
  });  

  if($dataEdtn === 'de' || $dataEdtn === 'ev_de') {
    const trendingWrapper = document.querySelector('.trending-content');
    const outbrainWrapper = document.querySelector('.outbrain_service');
    if(!!trendingWrapper && !!outbrainWrapper && window.innerWidth <= 1023) {
      const parentElement = outbrainWrapper.parentNode;
      parentElement.insertAdjacentElement('afterend', trendingWrapper);
    }
  }
  
  if ($dataEdtn != 'de' && $dataEdtn != 'ev_de' && !cpAuthhint && device.type == 'desktop') {
    function setSidebarTopPosition() {
      const trendingWidget = document.querySelector('.trending-content');
      const scrollSidebar = document.querySelector('.m1-newsfeed_sidebar-wrapper');
      const bodyTag = document.querySelector('body');
      
      let trendingWidgetHeight;
      if (trendingWidget) {
        trendingWidgetHeight = trendingWidget.offsetHeight;
      }
      
      let headerHeight = 221;
      const contentBeforeHeight = 638;
    
      if (bodyTag.classList.contains('no-rect-strip')) {
        headerHeight = 83;
      }
    
      const paddingNum = (trendingWidgetHeight + contentBeforeHeight) - headerHeight;
    
      if (scrollSidebar) {
        scrollSidebar.style.top = `-${paddingNum}px`;
      }
    }

    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        setSidebarTopPosition();
      }, 300);
    });
    setSidebarTopPosition();
  }

  const trendingItems = $('.trending-content_item:visible');

  trendingItems.each((index, item) => {
    $(item)
      .find('.item-index')
      .text(index + 1);
  });

  function setAdfeedData() {
    const articleTag = document.querySelector('.adfeed-container');
    const articleTopicId = articleTag ? articleTag.dataset.topicId : null;
    
    const m1ItUrls = articleTopicId == '506' ? ['/more-news/insideevs/'] : ['/more-news/insideevs/', '/more-news/omnifurgone/'];
    const evFrUrls = articleTopicId == '512' ? [ null ] : ['/more-news/insideevs/'];

    const adFeedConfigs = [
      {
        edtn: 'ra_us',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'us',
        urls: ['/more-news/insideevs/', '/more-news/rideapart/'],
      },
      {
        edtn: 'ev_us',
        urls: ['/more-news/motor1/', '/more-news/rideapart/'],
      },
      {
        edtn: 'it',
        urls: m1ItUrls,
      },
      {
        edtn: 'ev_it',
        urls: ['/more-news/motor1/', '/more-news/omnifurgone/'],
      },
      {
        edtn: 'ot',
        urls: ['/more-news/motor1/', '/more-news/insideevs/'],
      },
      {
        edtn: 'fr',
        urls: evFrUrls,
      },
      {
        edtn: 'ev_fr',
        urls: ['/more-news/motor1/'],
      },
      {
        edtn: 'es',
        urls: ['/more-news/motorsport/', '/more-news/motos/'],
      },
      {
        edtn: 'tr',
        urls: ['/more-news/insideevs/', '/more-news/motorsport/'],
      },
      {
        edtn: 'ev_tr',
        urls: ['/more-news/motor1/', '/more-news/motorsport/'],
      },
      {
        edtn: 'br',
        urls: ['/more-news/insideevs/', '/more-news/motos/'],
      },
      {
        edtn: 'ev_br',
        urls: ['/more-news/motor1/', '/more-news/motos/'],
      },
    ];

    const config = adFeedConfigs.find((cfg) => cfg.edtn === $dataEdtn);

    if (!config) return;

    const intersectingTarget = document.querySelector('.adfeed-container');

    if (intersectingTarget) {
      const intersectingOptions = {
        rootMargin: '100px'
      }

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('no-observe');
            observer.unobserve(intersectingTarget);
            const [url1, url2] = config.urls;
            getAdfeed(url1, url2, intersectingTarget);
          }
        }
      }, intersectingOptions);

      observer.observe(intersectingTarget);
    }
  };

  if (device.type == 'desktop') {
    let trendingItems = document.querySelectorAll('#article_box .related-item');
    for (let trendingItem of trendingItems) {
      let imgHeight = trendingItem.querySelector('.related-item-img').offsetHeight;
      let textHeight = trendingItem.querySelector('.title-related-item').offsetHeight;
      // console.log(trendingItem, imgHeight, textHeight, textHeight/imgHeight);
      if (textHeight/imgHeight > 1.62) {
        trendingItem.parentElement.classList.add('oneline');
      }
    }
  }

  setAdfeedData();
};